(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientType', PatientType);

    PatientType.$inject = ['$resource'];

    function PatientType ($resource) {
        var resourceUrl =  'api/patient-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
